'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _sizes = require('HubStyleTokens/sizes');

var _Styles = require('../utils/Styles');

var _PopoverContext = require('../context/PopoverContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handlePadding = function handlePadding(hasStructuredFooter, popoverUse) {
  if (popoverUse !== 'shepherd') return _sizes.POPOVER_PADDING_Y + ' ' + _sizes.POPOVER_PADDING_X;

  var paddingTop = hasStructuredFooter ? (0, _Styles.toPx)(parseInt(_sizes.POPOVER_PADDING_X, 10) - parseInt(_sizes.SHEPHERD_PADDING_Y, 10)) : '0px';
  var paddingBottom = hasStructuredFooter ? _sizes.POPOVER_PADDING_Y : _sizes.SHEPHERD_PADDING_Y;
  return paddingTop + ' ' + _sizes.POPOVER_PADDING_X + ' ' + paddingBottom + ' ' + _sizes.POPOVER_PADDING_X;
};

var UIPopoverFooter = _styledComponents2.default.footer.attrs({
  className: 'uiPopoverFooter private-popover__footer'
}).withConfig({
  displayName: 'UIPopoverFooter'
})(['background:inherit;border-radius:inherit;border-top-left-radius:0;border-top-right-radius:0;padding:', ';text-align:', ';', ';'], function (_ref) {
  var flush = _ref.flush,
      hasStructuredFooter = _ref.hasStructuredFooter,
      popoverContext = _ref.popoverContext;
  return flush ? '0' : handlePadding(hasStructuredFooter, popoverContext.use);
}, function (_ref2) {
  var align = _ref2.align;
  return align;
}, function (_ref3) {
  var hasStep = _ref3.hasStep;
  return hasStep ? (0, _styledComponents.css)(['display:flex;justify-content:space-between;align-items:center;']) : null;
});

UIPopoverFooter.propTypes = {
  align: _react.PropTypes.oneOf(['left', 'right']).isRequired,
  children: _react.PropTypes.node,
  flush: _react.PropTypes.bool,
  hasStep: _react.PropTypes.bool,
  hasStructuredFooter: _react.PropTypes.bool,
  popoverContext: _PopoverContext.popoverContextPropType
};

UIPopoverFooter.defaultProps = {
  align: 'left',
  hasStructuredFooter: false,
  hasStep: false
};

UIPopoverFooter.displayName = 'UIPopoverFooter';

exports.default = (0, _PopoverContext.ConsumesPopoverContext)(UIPopoverFooter);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/tooltip/UIPopoverFooter.js
// module id = 423
// module chunks = 3 4 5